import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBhqFBk9IcSXEOgirwgWjqIATV4iGIFZKg",
  authDomain: "rentwheels-18d43.firebaseapp.com",
  projectId: "rentwheels-18d43",
  storageBucket: "rentwheels-18d43.firebasestorage.app",
  messagingSenderId: "209769564251",
  appId: "1:209769564251:web:b2f59fbbd4150589c8177e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app); 